export default __webpack_public_path__ + "static/media/active-micro.b6e403e0.svg";